<template>
  <div :style="{
    display:'flex',
    cursor: 'pointer',
  }">
    <img
        ref="imgRef"
        :style="{ transform: `rotate(${angle}deg)`, width: width+'px',height: height+'px',}"
        :src="iconRotateImg"
        :class="{ rotating: isLooper }"
        alt=""
        @click="pressRotateImg"
    />
    <div @click="pressRotateImg" >
      <slot name="right"/>
    </div>
  </div>
</template>

<script setup>
  import {ref} from 'vue'
  import {hcf} from '@/components/utils/HComFunctions.js'

  const isRotating = ref(false)
  const imgRef = ref()
  let animateTimer = null;
  const iconRotateImg = hcf.getNewGameUIIcon('icon_lobby_refresh.png')

  const props = defineProps(["width", "height", "clickImg","isLooper"]);
  defineExpose({
    pressRotateImg
  })
  const isLooper = ref(props.isLooper??false);
  // 当前旋转角度（持续累加）
  const angle = ref(0)

  function pressRotateImg() {
    if (isRotating.value) return // 避免重复点击触发

    if (props.clickImg) {
      props.clickImg();
    }

    isRotating.value = true
    angle.value -= 720 // 每次加 360 度，确保方向不变

    if(animateTimer){
      clearTimeout(animateTimer);
      animateTimer = null;
    }
    animateTimer = setTimeout(()=>{
      isRotating.value = false
    },2000);
  }
  onUnmounted(()=>{
    if(animateTimer){
      clearTimeout(animateTimer);
      animateTimer = null;
    }
  });
</script>

<style scoped>

  img {
    width: 100%;
    height: 100%;
    transition: transform 2s ease;
  }
  .rotating {
    animation: rotateLoop 1s linear infinite;
  }

  @keyframes rotateLoop {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
